module.exports = __webpack_public_path__ + "img/CasinoChangeName_8499c2436d3ae148406e24eb905ca5fb_20211014001423.b8820a2f.png";